import { PurchaseOrder } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 0573. プロジェクト（費用）継続無し更新
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:id/update_not_renewed
 */
type Props = {
  identifier: string;
  team_id: number;
  id: number;
  not_renewed: boolean;
};

const updatePurchaseOrderNotRenewed = (props: Props): Promise<PurchaseOrder> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.id}/update_not_renewed`,
    props
  );
};

export const useUpdatePurchaseOrderNotRenewed = () => {
  return useMutation({
    mutationFn: updatePurchaseOrderNotRenewed,
  });
};
